import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useCurrencyCalc } from "@/hooks/useCurrencyCalc";

// extract the type from the array of that type
type Unpack<T> = T extends (infer U)[] ? U : T;

type TProductPriceInfoType = Unpack<IProduct["selling_prices"]>;

const ProductPriceInfo: React.FC<{
  productSpecialPrices: TProductPriceInfoType[];
}> = ({ productSpecialPrices }) => {
  return (
    <div className="product-price-info">
      <div className="layout">
        {productSpecialPrices?.map((item, index) => (
          <ProductPriceInfoItem key={index} productPriceInfoItem={item} />
        ))}
      </div>
    </div>
  );
};

export default ProductPriceInfo;

const ProductPriceInfoItem: React.FC<{
  productPriceInfoItem: TProductPriceInfoType;
}> = ({ productPriceInfoItem }) => {
  const { price, quantity, quantity_rule, unit_name } = productPriceInfoItem;
  return (
    <div className="item">
      <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
        <ProductInfoPrice price={price} />
        {unit_name && <ProductInfoUnit unit={unit_name} />}
      </div>
      <ProductInfoOffer
        quantity={quantity}
        role={quantity_rule}
        unit={unit_name}
      />
    </div>
  );
};

const ProductInfoPrice: React.FC<{ price: TProductPriceInfoType["price"] }> = ({
  price,
}) => {
  const { data } = useGetCompanyQuery();
  const { currency, getPriceString } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.enable_currencies_converter ?? true,
  });
  return (
    <p className="price">
      {getPriceString(price).concat(" ", currency.symbol)}
    </p>
  );
};

const ProductInfoUnit: React.FC<{ unit?: string }> = ({ unit }) => {
  const t = useTranslation();
  return <p className="unit">{`/ ${unit ?? t.item} `}</p>;
};

const ProductInfoOffer: React.FC<{
  unit?: string;
  quantity: TProductPriceInfoType["quantity"];
  role: TProductPriceInfoType["quantity_rule"];
}> = ({ quantity, unit }) => {
  const t = useTranslation();
  return (
    <p className="offer ">
      {t.for}
      <span className="offer-span m-1">{`>${quantity}`}</span>
      {unit ?? t.piece}
    </p>
  );
};
